import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { MapViewDimension } from './constants';

type MapViewDimensionSelectorProps = {
  value: MapViewDimension;
  onChange: (viewDimension: MapViewDimension) => void;
};

export const MapViewDimensionSelector = (
  props: MapViewDimensionSelectorProps,
): JSX.Element => {
  const { value, onChange } = props;
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={value}
      variant="watchduty-gap"
      sx={{ marginLeft: 2 }}
    >
      <ToggleButton
        value={MapViewDimension['2D']}
        onClick={() => onChange(MapViewDimension['2D'])}
      >
        {t('map.layers.dimensions.2D')}
      </ToggleButton>
      <ToggleButton
        value={MapViewDimension['3D']}
        onClick={() => onChange(MapViewDimension['3D'])}
      >
        {t('map.layers.dimensions.3D')}
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
